import script from "./JovenesPromesasView.vue?vue&type=script&setup=true&lang=js"
export * from "./JovenesPromesasView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__